const itemPickersUrlBase = '/_ghui/item-pickers'

export function buildItemPickersUrl(endpoint: 'assignees' | 'issue_types' | 'labels' | 'milestones' | 'projects') {
  return `${itemPickersUrlBase}/${endpoint}`
}

export function buildItemPickerSearchUrl(
  endpoint: 'assignees' | 'issue_types' | 'labels' | 'milestones' | 'projects',
  params = {},
) {
  const paramsString = new URLSearchParams(params).toString()
  return `${buildItemPickersUrl(endpoint)}${paramsString && `?${paramsString}`}`
}

export function buildItemPickersBulkActionsUrl() {
  return `${itemPickersUrlBase}/bulk_actions`
}
